module.exports = __webpack_public_path__ + "static/img/0545_3.53b8898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_3.jpg
// module id = 0XFl
// module chunks = 1